import {Route, Routes, useNavigate, useLocation} from 'react-router-dom';
import Login from '../components/login';
import Main from '../components/main';
import {useEffect, useState} from 'react';
import {getData} from '../services/api-handler';
import Topbar from '../components/topbar';
import Employee from '../components/employee';
import EmployeeReconcile from '../components/employee-reconcile';

export default function AppRouters() {
     const location = useLocation();
     const navigate = useNavigate();
     const [protectedRoutes, setProtectedRoutes] = useState(false);
     const [titile, setTitle] = useState('');

     useEffect(() => {
          const validateToken = async () => {
               const token = sessionStorage.getItem('token');
               const username = sessionStorage.getItem('userName');

               try {
                    const validating = await getData(`/validate?username=${username}&token=${token}`);
                    if (validating.status !== 200) {
                         setProtectedRoutes(false);
                         throw new Error('Token Kadaluarsa');
                    } else {
                         setProtectedRoutes(true);
                    }
               } catch (error) {
                    setProtectedRoutes(false);
                    navigate('/');
               }
          };
          if (location.pathname !== '/') {
               validateToken();
               switch (location.pathname) {
                    case '/main':
                         setTitle('Halaman Utama');
                         break;

                    case '/employee':
                         setTitle('Manajemen Karyawan');
                         break;

                    case '/employee/reconcile':
                         setTitle('Rekonsiliasi Karyawan');
                         break;

                    default:
                         setTitle('');
               }
          }
     }, [location, navigate]);

     return (
          <div>
               {protectedRoutes ? <Topbar title={titile} /> : ''}
               <Routes>
                    <Route path="/" exact element={<Login />} />
                    <Route path="/main" exact element={<Main />} />
                    <Route path="/employee" exact element={<Employee />} />
                    <Route path="/employee/reconcile" exact element={<EmployeeReconcile />} />
                    <Route path="/employee/list" exact element={<Employee />} />
                    <Route path="/employee/mail" exact element={<Employee />} />
               </Routes>
          </div>
     );
}
